<template lang="pug">
v-autocomplete(
  v-model="inputValue"
  :search-input.sync="search"
  multiple
  filled
  hide-details
  label="Выберите ключевые слова"
  :items="keyWords"
  item-text="name"
  item-value="id"
  @update:search-input="searchByName"
  :loading="loading"
  :return-object="returnObject"
)
  template(v-slot:append-item): div(v-intersect="intersect")

</template>
<script>
import autoAnswerService from '@/services/API/autoAnswer';

export default {
  props: {
    value: { type: [Number, String, Array], default: null },
    returnObject: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: true,
      search: null,
      pagination: {
        current: 1,
        length: 1,
      },
      keyWords: [],
    };
  },
  computed: {
    hasNextPage() {
      return this.pagination.current < this.pagination.length;
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  async created() {
    await this.init();
    this.loading = false;
  },
  methods: {
    searchByName(name) {
      this.pagination.current = 1;
      this.init(name);
    },
    intersect(isIntersecting) {
      if (isIntersecting && this.hasNextPage) {
        this.pagination.current += 1;
        this.init();
      }
    },
    async init(search) {
      this.loading = true;
      try {
        const response = await autoAnswerService.getKeyWords({
          'search[name]': search,
          'page': this.pagination.current,
          // 'per-page': 20,
        });
        this.pagination.length = +response.headers['x-pagination-page-count'];
        this.keyWords = search ? response.data.data : [...this.keyWords, ...response.data.data];
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.loading = false;
    },
  },
};
</script>
